import * as HttpService from "../../../../service/HttpService";

export const deviceSearch = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/CeDevicePeidianSoeRecord/getCeDeviceSoeRecordVoList", params);
};

export const minuteDeviceSearch = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/CeDevicePeidianSoeRecord/getCeDeviceSoeTimeVoList", params);
};
